import { api } from '../api/client';
import { API_ITEMS_COUNT_URL, API_ITEMS_URL } from '../utils';

/**
 * Related lists, the reads the card editor makes (keepr-api docs/SCHEMA.md,
 * Card definition, "Reading a list"). The lists themselves are written with
 * the card (its PATCH, `options.relatedLists`), never through here.
 */

/**
 * How many items one SAVED list finds for one item: the items list's own
 * count with `related_item` and `related_list`, under the list's default
 * filter. A list that can find nothing is not an error: it answers 0 and says
 * why in `X-Related-List-State` (removed, no_lookup, filter_unreadable…).
 * → `{ count, state }`, `count` null when the answer was not a number.
 */
export async function countRelatedList(itemId, listId) {
	const response = await api.get(API_ITEMS_COUNT_URL, { params: { related_item: itemId, related_list: listId } });
	const count = Number(response?.data?.count);
	const state = response?.headers?.['x-related-list-state'] || null;
	return { count: Number.isFinite(count) && count >= 0 ? count : null, state };
}

/**
 * An item of the card to try a list on: the newest the caller can read
 * (descendant cards included, as the card's lists show on them). → the item,
 * or null when the card has no item this person can read.
 */
export async function sampleItemOf(collectionId, cardId) {
	const response = await api.get(API_ITEMS_URL, {
		params: { collection_id: collectionId, card_id: cardId, include_descendants: true, limit: 1 },
	});
	const list = Array.isArray(response?.data) ? response.data : [];
	return list[0] || null;
}
